export default __webpack_public_path__ + "static/media/facilities_import_template.80a31f9e.csv";